module.exports = __webpack_public_path__ + "img/img38.3bc661f3.jpg";